export const TIMEZONES: { [key: string]: string } = {
  // Australia & Pacific
  'Australia/Melbourne': 'Melbourne, Australia (AEDT/AEST)',
  'Australia/Sydney': 'Sydney, Australia (AEDT/AEST)',
  'Australia/Brisbane': 'Brisbane, Australia (AEST)',
  'Australia/Perth': 'Perth, Australia (AWST)',
  'Australia/Adelaide': 'Adelaide, Australia (ACDT/ACST)',
  'Pacific/Auckland': 'Auckland, New Zealand (NZDT/NZST)',
  'Pacific/Fiji': 'Fiji (FJT)',

  // Asia
  'Asia/Tokyo': 'Tokyo, Japan (JST)',
  'Asia/Seoul': 'Seoul, South Korea (KST)',
  'Asia/Shanghai': 'Beijing, China (CST)',
  'Asia/Singapore': 'Singapore (SGT)',
  'Asia/Hong_Kong': 'Hong Kong (HKT)',
  'Asia/Bangkok': 'Bangkok, Thailand (ICT)',
  'Asia/Manila': 'Manila, Philippines (PST)',
  'Asia/Jakarta': 'Jakarta, Indonesia (WIB)',
  'Asia/Kolkata': 'Mumbai/New Delhi, India (IST)',
  'Asia/Dubai': 'Dubai, UAE (GST)',

  // Europe
  'Europe/London': 'London, UK (GMT/BST)',
  'Europe/Paris': 'Paris, France (CET/CEST)',
  'Europe/Berlin': 'Berlin, Germany (CET/CEST)',
  'Europe/Rome': 'Rome, Italy (CET/CEST)',
  'Europe/Madrid': 'Madrid, Spain (CET/CEST)',
  'Europe/Amsterdam': 'Amsterdam, Netherlands (CET/CEST)',
  'Europe/Zurich': 'Zurich, Switzerland (CET/CEST)',
  'Europe/Stockholm': 'Stockholm, Sweden (CET/CEST)',
  'Europe/Moscow': 'Moscow, Russia (MSK)',

  // Americas
  'America/New_York': 'New York, USA (ET)',
  'America/Los_Angeles': 'Los Angeles, USA (PT)',
  'America/Chicago': 'Chicago, USA (CT)',
  'America/Denver': 'Denver, USA (MT)',
  'America/Toronto': 'Toronto, Canada (ET)',
  'America/Vancouver': 'Vancouver, Canada (PT)',
  'America/Mexico_City': 'Mexico City, Mexico (CT)',
  'America/Sao_Paulo': 'São Paulo, Brazil (BRT)',
  'America/Buenos_Aires': 'Buenos Aires, Argentina (ART)',

  // Africa & Middle East
  'Africa/Cairo': 'Cairo, Egypt (EET)',
  'Africa/Johannesburg': 'Johannesburg, South Africa (SAST)',
  'Africa/Nairobi': 'Nairobi, Kenya (EAT)',
  'Africa/Lagos': 'Lagos, Nigeria (WAT)',
  'Asia/Jerusalem': 'Jerusalem, Israel (IST)',
  'Asia/Riyadh': 'Riyadh, Saudi Arabia (AST)'
};
